export const SEARCHING = 'SEARCHING';
export const SEARCH_COMPLETE = 'SEARCH_COMPLETE';
export const POLLING = 'POLLING';
export const INPUT_CHANGE = 'INPUT_CHANGE';
export const LEAD_CREATED = 'LEAD_CREATED';
export const POLL_ERROR = 'POLL_ERROR';
export const REPORT_LOADED = 'REPORT_LOADED';
export const LOADING = 'LOADING';
export const LOADING_COMPLETE = 'LOADING_COMPLETE';
export const STAFF_CHECK = 'STAFF_CHECK';
export const POLL_TIMEOUT = 'POLL_TIMEOUT';
export const SEARCH_PARAM = 'SEARCH_PARAM';
export const DECRYPT_CUSTOMER_DATA = 'DECRYPT_CUSTOMER_DATA';
